import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  enableBtn: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.enableBtn',
    defaultMessage: 'Enable',
  },
  disableBtn: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.disableBtn',
    defaultMessage: 'Disable',
  },
  connect: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.connect',
    defaultMessage: 'Connect my account',
  },
  connectDemo: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.connectDemo',
    defaultMessage: 'Connect with a demo account',
  },
  disconnect: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.disconnect',
    defaultMessage: 'Disconnect',
  },
  enabledOptions: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.enabledOptions',
    defaultMessage: 'Enabled Options',
  },
  category: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.category',
    defaultMessage: 'Category',
  },
  tabDescription: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.tabDescription',
    defaultMessage: 'Description',
  },
  tabConfiguration: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.tabConfiguration',
    defaultMessage: 'Configuration',
  },
  tabRegistration: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.tabRegistration',
    defaultMessage: 'New Registration',
  },
  tabRegistrations: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.tabRegistrations',
    defaultMessage: 'Registrations',
  },
  configurationAlert: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.configurationAlert',
    defaultMessage: 'Please enable this EHR before setting the configuration fields.',
  },
  requiredField: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.requiredField',
    defaultMessage: 'is required.',
  },
  confirmDialogTitle: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.ConfirmDialog.confirmDialogTitle',
    defaultMessage: 'Confirm Changes and Save',
  },
  confirmDialogContent: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowIntegration.ConfirmDialog.confirmDialogContent',
    defaultMessage: 'Are you sure you want to',
  },
  saveSuccess: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.saveSuccess',
    defaultMessage: 'Saved Successfully',
  },
  deleteSuccess: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.deleteSuccess',
    defaultMessage: 'Deleted Successfully',
  },
  resyncA2PSuccess: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.resyncA2PSuccess',
    defaultMessage: "We've started re-syncing the A2P registration's status. This can take a minute to complete.",
  },
  fetchError: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.fetchError',
    defaultMessage: 'Something went wrong.',
  },
  closeText: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.closeText',
    defaultMessage: 'Close',
  },
  modalValidateTitle: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowPaymentIntegration.modalValidateTitle',
    defaultMessage: 'We could not connect to your billing vendor',
  },
  modalValidateContent: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowPaymentIntegration.modalValidateContent',
    defaultMessage: 'Please double check your credentials and try again.',
  },
  success: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowPaymentIntegration.success',
    defaultMessage: 'Settings saved successfully',
  },
  error: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.ShowPaymentIntegration.error',
    defaultMessage: 'We had an issue changing settings. Please, try again.',
  },
  connectedOn: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.connectedOn',
    defaultMessage: 'Connected on',
  },
  user: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.user',
    defaultMessage: 'User',
  },
  connectedAccount: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.connectedAccount',
    defaultMessage: 'Connected Account',
  },
  switchAccount: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.switchAccount',
    defaultMessage: 'Switch account',
  },
  beforeDisconnectTitle: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.beforeDisconnectTitle',
    defaultMessage: 'Before you disconnect',
  },
  selectAccountsTitle: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.selectAccountsTitle',
    defaultMessage: 'Select DocuSign account',
  },
  beforeDisconnectContent1: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.beforeDisconnectContent1',
    defaultMessage: 'The following forms use DocuSign templates from the DocuSign account currently linked to Luma:',
  },
  beforeDisconnectContent2: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.beforeDisconnect',
    defaultMessage:
      'You must update these forms to no longer include DocuSign questions before you can disconnect the currently linked DocuSign account.',
  },
  beforeDisconnectContent3: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.beforeDisconnect',
    defaultMessage: "Otherwise, patients won't be able to use these forms.",
  },
  beforeDisconnectClose: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.beforeDisconnectClose',
    defaultMessage: 'Close',
  },
  openInNewTab: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.openInNewTab',
    defaultMessage: 'Open in a new tab',
  },
  closeModal: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.closeModal',
    defaultMessage: 'Close',
  },
  cancelModal: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.cancelModal',
    defaultMessage: 'Cancel',
  },
  notFound: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.vendorNotFound',
    defaultMessage: '404 Not found',
  },
  selectAccount: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.selectAccount',
    defaultMessage: 'Select account',
  },
  questionnaires: {
    id: 'screens.MissionControl.Utilities.ThirdPartyIntegrations.questionnaires',
    defaultMessage: 'Questionnaires',
  },
});
